export const educationData = [
    {
        id: 1,
        institution: 'University of Engineering & Management (UEM)',
        course: 'Bachelor of technology- BTech, Computer Science',
        startYear: '2020',
        endYear: '2024'
    },
    {
        id: 2,
        institution: 'BSEB',
        course: 'Higher Secondary',
        startYear: '2017',
        endYear: '2019'
    },
    {
        id: 3,
        institution: 'CBSE',
        course: 'Matriculation',
        startYear: '2016',
        endYear: '2017'
    },
]